module.exports = __webpack_public_path__ + "img/close.14bf672c.png";